import axios from "axios";
import { buildInsuranceAddPaxRequest } from "../Services/buildInsuranceAddPaxRequest";
const InsuranceAPI_BASE_URL = process.env.REACT_APP_InsuranceAPI_BASE_URL;

export const getInsuranceCategory = async () => {
 
  try {
    const { data } = await axios.get(
      `${InsuranceAPI_BASE_URL}/api/Insurance/category`
    );
    return data;
  } catch (error) {
    
    throw error;
  }
};

export const GetPlan = async (requestBody) => {
  try {
    const resp = await axios.post(
      `${InsuranceAPI_BASE_URL}/api/Insurance/GetPlan`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return resp.data;
  } catch (err) {
    console.error("Insurance Get Plan error:", err);
    throw err;
  }
};



export const GetSelectedInsurance = async (
  requestBody
) => {
  try {
    console.log(
      "SAVE SELECTED INSURANCE REQUEST:",
      JSON.stringify(
        requestBody,
        null,
        2
      )
    );

    const response = await axios.post(
      `${InsuranceAPI_BASE_URL}/api/Insurance/SaveSelectedInsurancePlan`,
      requestBody,
      {
        headers: {
          "Content-Type":
            "application/json",
          Accept:
            "application/json",
        },
      }
    );

    console.log(
      "SAVE SELECTED INSURANCE RESPONSE:",
      response.data
    );

    return response.data;
  } catch (error) {
    console.error(
      "SAVE SELECTED INSURANCE ERROR:",
      error?.response?.data || error
    );

    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong",
      data:
        error?.response?.data || null,
    };
  }
};

export const AddPassengerDetails = async ({ clientCode, key, referenceNo, userName,contactDetails, travellerData, riders }) => {
  const requestBody = buildInsuranceAddPaxRequest({ clientCode, key, referenceNo, userName, contactDetails, travellerData, riders });
  // debugger
  console.log("BASE URL 2:", InsuranceAPI_BASE_URL);
  console.log("AddPassengers requestBody:", requestBody);
  try {
    const response = await axios.post(
      `${InsuranceAPI_BASE_URL}/api/Insurance/AddPassengers`,
      requestBody,
      {
        headers: {
          "Accept": "text/plain",
          "Content-Type": "application/json",
        },
      }
    );
    console.log("AddPassengerDetails --> response:", response.data);
    return response.data;
  } catch (error) {
    console.error("AddPassengerDetails --> error:", error.response?.data || error.message);
    throw error;
  }
};

export const CreatePolicy = async (requestBody) => {
  console.log("CreatePolicy Request:", requestBody);

  try {
    const resp = await axios.post(
      `${InsuranceAPI_BASE_URL}/api/Insurance/CreatePolicy`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    console.log("CreatePolicy Response:", resp.data);

    return resp.data;
  } catch (err) {
    console.error(
      "Create Policy Error:",
      err.response?.data || err.message
    );

    throw err;
  }
};

export const CancelBookedPolicy = async (requestBody) => {
  console.log("CreatePolicy Request:", requestBody);

  try {
    const resp = await axios.post(
      `${InsuranceAPI_BASE_URL}/api/Insurance/CancelBookedInsurancePolicy`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    console.log("Cancel Booked Response:", resp.data);

    return resp.data;
  } catch (err) {
    console.error(
      "Cancel Booked Error:",
      err.response?.data || err.message
    );

    throw err;
  }
};
export const GetTransactionDetails = async (requestBody) => {

 console.log("GetTransactionDetails request", requestBody);

  try {
debugger;
    const resp = await axios.post(
      `${InsuranceAPI_BASE_URL}/api/Insurance/GetTransactionDetails`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    return resp.data;

  } catch (err) {

    console.error(
      "GetTransactionDetails error:",
      err
    );

    throw err;
  }
};

export const RetrieveSelectedPlan =
  async (referenceNo) => {
    try {
      const { data } =
        await axios.get(
          `${InsuranceAPI_BASE_URL}/api/Insurance/RetrieveSelectedPlan?ReferenceNo=${referenceNo}`
        );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
